import { TexturePreview } from '../textures/TexturePreview';
import { getMilestoneShape } from '../items/milestones/milestone';
import { isTruthy } from '@ardoq/common-helpers';
import { FieldsRegistryItem } from '../types';

type GetLegendRowsArgs = {
  orderedSelectedPhaseFields: FieldsRegistryItem[];
  orderedSelectedMilestoneFields: FieldsRegistryItem[];
  phasesTitle?: string;
  milestonesTitle?: string;
};

export const getLegendRows = ({
  orderedSelectedPhaseFields,
  orderedSelectedMilestoneFields,
  phasesTitle = 'Phases',
  milestonesTitle = 'Milestones',
}: GetLegendRowsArgs) => {
  const phaseLegendItems = orderedSelectedPhaseFields.map(
    ({ label }, index) => ({
      label,
      getShape: () => TexturePreview({ textureIndex: index }),
    })
  );

  const milestoneLegendItems = orderedSelectedMilestoneFields.map(
    ({ label }, index) => ({
      label: label,
      color: 'black',
      getShape: (size: number) => getMilestoneShape(index, size),
    })
  );

  return [
    phaseLegendItems.length > 0 && {
      id: 'Phases',
      title: phasesTitle,
      sections: [{ heading: null, items: phaseLegendItems }],
    },
    milestoneLegendItems.length > 0 && {
      id: 'Milestones',
      title: milestonesTitle,
      sections: [{ heading: null, items: milestoneLegendItems }],
    },
  ].filter(isTruthy);
};
